import React from 'react';
import {connect} from 'react-redux';
import Hamburger from 'react-hamburgers';

import AppMobileMenu from './AppMobileMenu';
import {setEnableClosedSidebar} from '../actions/ThemeOptions';


const HeaderLogo = (
    {
        enableClosedSidebar,
        setEnableClosedSidebar,
    }
) => {
    return <>
        <div className="app-header__logo">
            <div className="logo-src"/>
            <div className="header__pane ml-auto">
                <div onClick={() => setEnableClosedSidebar(!enableClosedSidebar)}>
                    <Hamburger
                        active={enableClosedSidebar}
                        type="elastic"
                    />
                </div>
            </div>
        </div>
        <AppMobileMenu/>
    </>;
}


const mapStateToProps = state => ({
    enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
});

const mapDispatchToProps = dispatch => ({
    setEnableClosedSidebar: enable => dispatch(setEnableClosedSidebar(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderLogo);